module.exports = __webpack_public_path__ + "media/custom/images/pocstock-contributor-collage-1-0755df98f400717e16d3b518ed50bb44.png";